var map = {
	"./gift-bg.png": 46974,
	"./icon-star.png": 36281,
	"./icon-star2.png": 16558,
	"./key.png": 64765,
	"./light1-gift.png": 6530,
	"./light1.png": 94421,
	"./light2-gift.png": 88083,
	"./light2.png": 73133,
	"./lucky-btn-bg.png": 2548,
	"./lucky-btn2.png": 50982,
	"./lucky-item-bg-gift.png": 73161,
	"./lucky-item-bg.png": 48012,
	"./lucky-result-coin-tap.png": 55788,
	"./lucky-result-coin-tapcoins.png": 16414,
	"./lucky-result-coin-tapstock.png": 43375,
	"./lucky-result-coin-ton.png": 82649,
	"./lucky-result-coin-usdt.png": 11104,
	"./lucky-result-light.png": 60268,
	"./tap.png": 35092,
	"./tapcoins.png": 78565,
	"./tapgiftshard.png": 31965,
	"./ton.png": 52808,
	"./usdt.png": 5976
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25504;